<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchImportMaterial" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสวัตถุดิบ"
                        v-model="search.code"
                        aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchImportMaterial">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">วันที่นำเข้า</th>
                    <th scope="col">เลขใบสั่งซื้อ</th>
                    <th scope="col">รหัสวัตถุดิบ</th>
                    <th scope="col">รายการ</th>
                    <th scope="col">จำนวนนำเข้า</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <th scope="col">หมายเหตุ</th>
                    <!--<th scope="col">แก้ไข / ลบ</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in material">
                    <td>
                        <template v-if="data.import_date">
                            {{ data.import_date | moment("DD/MM/YYYY") }}
                        </template>

                    </td>
                    <td>
                        <template v-if="data.po_number">
                            {{ data.po_number }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.materials">
                            {{ data.materials.code }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.materials">
                            {{ data.materials.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.quantity }} {{ data.materials ? data.materials.type_unit : '' }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <td>{{ data.reason }}</td>
                    <!--<td>-->
                    <!--<a @click="showImportMaterial(data.id)">-->
                    <!--<icon name="pencil-alt">-->
                    <!--</icon>-->
                    <!--</a>-->
                    <!--&nbsp;&nbsp;-->
                    <!--<a @click="showDeleteModal(data.id)">-->
                    <!--<icon name="trash"></icon>-->
                    <!--</a>-->
                    <!--</td>-->
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="material.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getMaterialImportPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- Modal Delete -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteImportMaterial">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal Edit ImportMaterial -->
        <b-modal
            hide-footer
            ref="edit_data"
            id="import"
            title="นำเข้าวัตถุดิบ">
            <div v-if="material_import.materials">
                <b-row sm="10">
                    <b-col sm="4" class="col text-right"><label>Lot วันที่</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="date"
                        v-model="material_import.import_date"/></b-col>
                </b-row>
                <br/>
                <b-row sm="11" v-if="material_import.materials">
                    <b-col sm="4" class="col text-right"><label>รหัสวัตถุดิบ</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="material_import.materials.code" disabled/></b-col>
                </b-row>
                <br/>
                <b-row sm="10" v-if="material_import.materials">
                    <b-col sm="4" class="col text-right"><label>รายการ</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="material_import.materials.name" disabled/></b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right"><label>เลขใบสั่งซื้อ</label></b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="material_import.PO_number"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="10">
                    <b-col sm="4" class="col text-right"><label>จำนวนนำเข้า</label></b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="number"
                            v-model="material_import.quantity" disabled/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveImportMaterial">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button type="button"
                                @click="hideEditModal"
                                class="btn btn-outline-secondary">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
        </b-modal>
        <!--        <pre class="alert alert-primary">{{ material }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment"

export default {
    components: {VuePagination, DatePicker},
    name: "materials-import",
    created() {
        this.$store.dispatch("ImportMaterial/get").then(res => {
            this.material = res.data;
            this.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        });
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            material_import: state => {
                return state.ImportMaterial.replace_data;
            },
        })
    },
    data() {
        return {
            id: "",
            activeCloseDate: false,
            dateFormat: 'D/MM/YYYY',
            dateOne: '',
            search: {
                code: "",
                date: ""
            },
            form: {
                code: "",
                name: "",
                quantity_import: "",
                balance: "",
                PO_number: ""
            },
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            material: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
        };
    },
    methods: {
        //Modal
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },

        showEditModal(id) {
            this.id = id;
            this.$refs.edit_data.show();
        },
        hideEditModal() {
            this.$refs.edit_data.hide();
        },

        // API
        showImportMaterial(id) {
            this.showEditModal(id);
            this.$store.dispatch("ImportMaterial/show", id);
        },
        deleteImportMaterial() {
            this.$store.dispatch("ImportMaterial/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.getMaterialImportPage();
            });
        },
        saveImportMaterial() {
            let data = {
                import_date: this.material_import.import_date,
                PO_number: this.material_import.PO_number,
                material_id: this.material_import.material_id,
                quantity: this.material_import.quantity,
                status: this.material_import.status,
                user_id: this.user.id
            };
            this.id = this.material_import.id;
            this.$store.dispatch("ImportMaterial/update", {
                id: this.id,
                data: data
            })
                .then(() => {
                    this.hideEditModal();
                    this.getMaterialImportPage();
                });
        },
        searchImportMaterial() {
            this.event_submit = true;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            this.$store.dispatch("ImportMaterial/search", {
                code: this.search.code,
                date: this.search.date
            }).then(res => {
                this.material = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.form,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        getMaterialImportPage() {
            const page = this.dataPaginate.current_page;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            if (this.event_submit) {
                this.$store.dispatch("ImportMaterial/search", {
                    page: page,
                    code: this.search.code,
                    date: this.search.date
                }).then(res => {
                    this.material = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                });
            } else {
                this.$store.dispatch('ImportMaterial/get', page).then(res => {
                    this.material = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
td > a {
    cursor: pointer;
    color: red;
}

.border-left-0 {
    border-left: 0;
}

a.disabled {
    pointer-events: none;
    cursor: default;
}
</style>
